import { Box, HStack, Text, VStack, useToast, Icon } from '@chakra-ui/react';
import { IoCopyOutline } from 'react-icons/io5';
import useCurrencyFormatter from '../hooks/useCurrencyFormatter';
import QRCode from 'qrcode';
import { useEffect, useState } from 'react';

type Props = {
  keyValue?: string;
  qrValue: string;
  amount: number;
  showQR?: boolean;
};

export const BrebPaymentAwait = ({ keyValue, qrValue, amount, showQR = false }: Props) => {
  const toast = useToast();
  const formatCurrency = useCurrencyFormatter();
  const [qrDataURL, setQrDataURL] = useState<string>('');

  useEffect(() => {
    if (showQR) {
      QRCode.toDataURL(qrValue)
        .then((dataURL) => setQrDataURL(dataURL))
        .catch((error) => {
          console.error('Error generating QR code:', error);
        });
    }
  }, [showQR, qrValue]);

  const handleCopy = (value: string, label: string) => {
    navigator.clipboard.writeText(value);
    toast({
      title: `${label} al portapapeles`,
      status: 'success',
      duration: 2000,
    });
  };

  return (
    <Box mt={8}>
      <VStack>
        <Text fontSize={'16px'} textAlign={'center'} px={8}>
          Paga a través de la app de tu banco en los próximos 5 minutos
          {keyValue ? ' con la siguiente llave Bre-B' : ''}
          {keyValue && showQR ? ' o' : ''}
          {showQR ? ' escaneando el código QR' : ''}
        </Text>
        {showQR && <img width={'200px'} height={'200px'} src={qrDataURL} alt="QR Code" />}
        {keyValue && (
          <>
            <HStack gap={1} onClick={() => handleCopy(keyValue, 'Llave Bre-B copiada')} cursor={'pointer'}>
              <Icon as={IoCopyOutline} fontSize={'1.5rem'} />
              <Text fontSize={'20px'} fontWeight={'bold'}>
                {keyValue}
              </Text>
            </HStack>
            <Text px={8} textAlign={'center'} fontSize={showQR ? '12px' : '16px'}>
              Si pagas con llave, ingresa el <b>valor exacto</b>:{' '}
              <b onClick={() => handleCopy(amount.toString(), 'Valor a pagar copiado')} style={{ cursor: 'pointer' }}>
                <Icon as={IoCopyOutline} /> {formatCurrency(amount)}
              </b>{' '}
              para que el pago sea exitoso
            </Text>
          </>
        )}
      </VStack>
    </Box>
  );
};
